import { useDocumentTitle } from "@mantine/hooks";

function useTitle(title) {
  const titleText = `${import.meta.env.DEV ? "[DEV] " : ""}${title ? `${title} — ` : " "}Panel`;

  useDocumentTitle(titleText);
}

export default useTitle;
